import {  Button  } from "@mui/material";
import { connect } from 'react-redux';

interface UploadButtonProps {
  toggleModal: Function;
  disabled: boolean;
  multiple: boolean;
  name: string;
  component: string;
}

class UploadButton extends window.React.PureComponent<UploadButtonProps> {
  onFilesSelect = (event: React.ChangeEvent) => {
    event.preventDefault();
    //This condition prevents IE from considering input value cleaning as no files selection, which breaks UploadModal.
    if (event.target.files.length > 0) {
      const { toggleModal, name } = this.props;
      const items: any = event.target.files;
      const files: any = [];
      [...items].forEach(item => files.push(item));
      toggleModal(true, name, { files });
      //If we wouldn't do it, the input could work unpredictably, for example, not reopening file selection window.
      document.getElementById(name ? `${name}FileInput` : 'uploadFileInput').value = null;
    }
  };

  render() {
    const { disabled, multiple, component, name } = this.props;
    return (
      <div className="Upload-Button">
        {!disabled && (
          <input
            id={name ? `${name}FileInput` : 'uploadFileInput'}
            type="file"
            onChange={this.onFilesSelect}
            multiple={multiple}
            style={{ display: 'none' }}
          />
        )}
        {component && <label htmlFor={name ? `${name}FileInput` : 'uploadFileInput'}>{component}</label>}
        {!component && (
          <label htmlFor={name ? `${name}FileInput` : 'uploadFileInput'}>
            <Button
              disabled={disabled}
              variant={'outlined'}
              component={'span'}
              sx={{
                padding: '5px 15px !important',
                margin: '0 5px 0 0 !important',
                lineHeight: '1.4',
              }}
            >
              {window.Alfresco.messages.global['edocat.button.upload']}
            </Button>
          </label>
        )}
      </div>
    );
  }
}

export default connect(null, null)(UploadButton);
